import { isBanamexTenant } from "./banamex";

/**
 * El export con la plantilla "Investigation Case Import" (ServiceNow) es
 * exclusivo de Banamex: el backend lo restringe por schema en
 * `BanamexTenantMixin` y responde 403 a cualquier otro tenant.
 *
 * Aqui se replica esa regla por dominio para no ofrecerle a los demas clientes
 * una opcion que les va a fallar.
 *
 * @returns {boolean} true si el tenant actual puede generar el export ServiceNow
 */
export const isServiceNowExportEnabled = () => isBanamexTenant();
